import React, { useState } from 'react';
import { Col, Form, Input, Row, DatePicker, Table, Button, Pagination } from 'antd';
import { Select } from 'antd';
import { BiSearchAlt } from "react-icons/bi";
import { CiExport } from "react-icons/ci";
import { CiImport } from "react-icons/ci";
import { LuSearch } from "react-icons/lu";
import { LuFilter } from "react-icons/lu";
import { dropdownService, ledgerService } from '../../../services';
import { ROLES } from '../../../constants';

function CustomerLedger() {
    const status = [{ id: 1, name: "All" }, { id: 2, name: "Opened" }, { id: 3, name: "Closed" }];

    const role = localStorage.getItem("role");
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    const [form] = Form.useForm();
    const [pdfload, setPDFLoad] = useState(false)
    const [ledger, setLedger] = useState([]);
    const [filteredLedger, setFilteredLedger] = useState([])
    const [payload, setPayload] = useState(null)
    const [customers, setCustomers] = useState([]);
    const [invoices, setInvoices] = useState([])
    const [loading, setLoading] = useState(false)
    const [customerId, setCustomerId] = useState(role === ROLES.CUSTOMER ? loggedInUser.id : 0);

    const columns = [
        {
            title: "#",
            dataIndex: '#',
            key: '#',
            render: (text, record, index) => index + 1,
        },
        {
            title: "STATUS",
            dataIndex: 'STATUS',
            key: 'STATUS',

        },
        {
            title: "INVOICE DATE",
            dataIndex: "INVOICE DATE",
            key: "INVOICE_DATE",

        },
        {
            title: "INVOICE NUMBER",
            dataIndex: "INVOICE NUMBER",
            key: "INVOICE_NUMBER",

        },
        {
            title: "RECEIPT NUMBER",
            dataIndex: "RECEIPT NUMBER",
            key: "RECEIPT_NUMBER",

        }, {
            title: "CREDIT NUMBER",
            dataIndex: "CREDIT NUMBER",
            key: "CREDIT_NUMBER",


        }, {
            title: "DESCRIPTION",
            dataIndex: "DESCRIPTION",
            key: "DESCRIPTION",

        },
        {
            title: "INVOICE AMOUNT",
            dataIndex: "INVOICE AMOUNT",
            key: "INVOICE_AMOUNT",

        },
        {
            title: "CREDIT AMOUNT",
            dataIndex: "CREDIT AMOUNT",
            key: "CREDIT_AMOUNT",

        },
        {
            title: "COLLECTED AMOUNT",
            dataIndex: "COLLECTED AMOUNT",
            key: "COLLECTED_AMOUNT",

        },
        {
            title: "BALANCE",
            dataIndex: "BALANCE",
            key: "BALANCE",

        },
    ]
    // const data = [
    //     {
    //         STATUS: "Opened",
    //         BALANCE: "900",
    //         COLLECTED_AMOUNT: "-",
    //         CREDIT_AMOUNT: "-",
    //         INVOICE_AMOUNT: "$900",
    //         DESCRIPTION: "TCKU7171069",
    //         CREDIT_NUMBER: "-",
    //         RECEIPT_NUMBER: "-",
    //         INVOICE_NUMBER: "INVOICE # 5508",
    //         INVOICE_DATE: "21 Oct, 2024",
    //     },
    //     {
    //         STATUS: "Opened",
    //         BALANCE: "900",
    //         COLLECTED_AMOUNT: "-",
    //         CREDIT_AMOUNT: "-",
    //         INVOICE_AMOUNT: "$900",
    //         DESCRIPTION: "TCKU7171069",
    //         CREDIT_NUMBER: "-",
    //         RECEIPT_NUMBER: "-",
    //         INVOICE_NUMBER: "INVOICE # 5508",
    //         INVOICE_DATE: "21 Oct, 2024",
    //     },
    //     {
    //         STATUS: "Opened",
    //         BALANCE: "900",
    //         COLLECTED_AMOUNT: "-",
    //         CREDIT_AMOUNT: "-",
    //         INVOICE_AMOUNT: "$900",
    //         DESCRIPTION: "TCKU7171069",
    //         CREDIT_NUMBER: "-",
    //         RECEIPT_NUMBER: "-",
    //         INVOICE_NUMBER: "INVOICE # 5508",
    //         INVOICE_DATE: "21 Oct, 2024",
    //     },
    //     {
    //         STATUS: "Opened",
    //         BALANCE: "900",
    //         COLLECTED_AMOUNT: "-",
    //         CREDIT_AMOUNT: "-",
    //         INVOICE_AMOUNT: "$900",
    //         DESCRIPTION: "TCKU7171069",
    //         CREDIT_NUMBER: "-",
    //         RECEIPT_NUMBER: "-",
    //         INVOICE_NUMBER: "INVOICE # 5508",
    //         INVOICE_DATE: "21 Oct, 2024",
    //     }
    // ]
    const handleSearch = ({ search }) => {
        if (!search) {
            setFilteredLedger(ledger.data);
            return;
        }

        const searchTerm = search.toLowerCase();
        const filteredData = ledger.data.filter((item) =>
            item["INVOICE NUMBER"]?.toString().toLowerCase().includes(searchTerm) ||
            item["DESCRIPTION"]?.toLowerCase().includes(searchTerm)
        );

        setFilteredLedger(filteredData);
        
    };

    const handleFilter = async (values) => {
        const payload = {
            ...values,
            user_id: values.user,
            from_date: values.from_date ? values.from_date.format("YYYY-MM-DD") : null,
            to_date: values.to_date ? values.to_date.format("YYYY-MM-DD") : null,
            status: values.status === "All" ? null : values.status,
        };

        const filteredData = Object.fromEntries(
            Object.entries(payload).filter(([_, value]) => value != null)
        );
        delete filteredData.user;

        setPayload(filteredData);
        initialize(filteredData);

        // 🔹 Run search filtering if 'search' field is used
        if (values.search) {
            handleSearch({ search: values.search });
        } else {
            setFilteredLedger(ledger.data); // reset to full data
        }
    };

    const initialize = async (data = null, search = null) => {
        setLoading(true)
        const { success, data: LedgerData } = await ledgerService.fetch(data, search);
        setLoading(false)
        if (success) {
            setLedger(LedgerData);
            setFilteredLedger(LedgerData.data)
            const invoiceData = LedgerData.data.map((item) => item['INVOICE NUMBER']);
            setInvoices(invoiceData)
        }
    };

    const getCustomers = async () => {
        const response = await dropdownService.fetchCustomers();
        if (response.success) {
            setCustomers(response.data);
        }
    };

    const parseAmount = (value) => {
        if (!value || value === "-") return 0;
        return Number(value.replace(/[^0-9.-]+/g, ""));
    };

    return (
        <div >
            <Form
                requiredMark={false}
                layout="vertical"
                form={form}
                onFinish={handleFilter}
                initialValues={{ status: "All" }}
            >
                <Row gutter={[16, 16]} className="mt-8">
                    {/* 🔍 Search Input */}
                    <Col span={5}>
                        <Form.Item label="Search" name="search">
                            <Input
                                style={{ width: "100%", height: "45px" }}
                                prefix={<LuSearch />}
                                placeholder="Invoice no Container no"
                                allowClear
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item label="From date" name="from_date">
                            <DatePicker style={{ width: "100%", height: "45px" }} />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item label="To date" name="to_date">
                            <DatePicker style={{ width: "100%", height: "45px" }} />
                        </Form.Item>
                    </Col>

                    {role !== ROLES.CUSTOMER && (
                        <Col span={6}>
                            <Form.Item
                                label="Customers"
                                name="user"
                                rules={[{ required: true, message: "Please select a customer!" }]}
                            >
                                <Select
                                    placeholder="Select Customer"
                                    showSearch
                                    optionFilterProp="children"
                                    onChange={(e) => setCustomerId(e)}
                                >
                                    {customers?.map((cust) => (
                                        <Select.Option key={cust.id} value={cust.id}>
                                            {cust.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    )}

                    {customerId > 0 && (
                        <Col span={6}>
                            <Form.Item
                                label="Status"
                                name="status"
                                rules={[{ required: true, message: "Please input!" }]}
                            >
                                <Select placeholder="No Customer" className="h-11">
                                    {status?.map((s) => (
                                        <Select.Option key={s.id} value={s.name}>
                                            {s.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    )}

                    {/* Buttons */}
                    <Col span={5} className="mt-7 flex gap-3">
                        <Button
                            className="h-11"
                            type="default"
                            size="middle"
                            htmlType="submit"
                            icon={<BiSearchAlt style={{ fontSize: 20 }} />}
                        >
                            Search
                        </Button>

                        <Button
                            className="h-11"
                            type="default"
                            size="middle"
                            icon={<LuFilter style={{ fontSize: 20 }} />}
                            onClick={() => {
                                form.resetFields();
                                // setCustomerId(0);    
                                setFilteredLedger(ledger.data);
                                handleFilter({});
                            }}
                        >
                            Reset
                        </Button>
                    </Col>
                </Row>
            </Form>


            <Col span={24}>
                {/* <div className='flex justify-end gap-3 mb-7 mt-4'>
                    <Button className='bg-[#EEF2F6]' icon={<CiImport style={{ fontSize: "20px" }} />}>Import CSV</Button>
                    <Button className='bg-[#EEF2F6]' icon={<CiExport style={{ fontSize: "20px" }} />}>Export CSV</Button>
                </div> */}

                <div className="customer1-table-wrapper" style={{ marginTop: "5px" }}>
                    <Table
                        columns={columns}
                        dataSource={filteredLedger}
                        rowKey="Id"
                        scroll={{ x: "max-content" }}
                        pagination={false}
                        footer={() => {
                            const data = Array.isArray(filteredLedger) ? filteredLedger : [];

                            const totals = data.reduce(
                                (t, r) => ({
                                    invoice: t.invoice + parseAmount(r["INVOICE AMOUNT"]),
                                    credit: t.credit + parseAmount(r["CREDIT AMOUNT"]),
                                    collected: t.collected + parseAmount(r["COLLECTED AMOUNT"]),
                                    balance: t.balance + parseAmount(r["BALANCE"]),
                                }),
                                { invoice: 0, credit: 0, collected: 0, balance: 0 }
                            );

                            return (
                                <div className="flex justify-end gap-20 mt-2 mb-2 font-semibold">
                                    <p>TOTAL:</p>
                                    <p>${totals.invoice.toFixed(2)}</p>
                                    <p>${totals.credit.toFixed(2)}</p>
                                    <p>${totals.collected.toFixed(2)}</p>
                                    <p>${totals.balance.toFixed(2)}</p>
                                </div>
                            );
                        }}
                    />
                </div>
            </Col >
        </div >
    );
}

export default CustomerLedger;
